var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgTrendingDown = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5957 16.2411V12.3191C21.5957 11.9314 21.9101 11.617 22.2979 11.617C22.6856 11.617 23 11.9314 23 12.3191V17.9362C23 18.3239 22.6856 18.6383 22.2979 18.6383H16.6809C16.2931 18.6383 15.9787 18.3239 15.9787 17.9362C15.9787 17.5484 16.2931 17.234 16.6809 17.234H20.6028L13.4043 10.0355L9.21988 14.2199C8.94569 14.4941 8.50112 14.4941 8.22692 14.2199L1.20565 7.19861C0.931451 6.92441 0.931451 6.47985 1.20565 6.20565C1.47985 5.93145 1.92441 5.93145 2.19861 6.20565L8.7234 12.7304L12.9078 8.54607C13.182 8.27188 13.6265 8.27188 13.9007 8.54607L21.5957 16.2411Z",
    fill: props.color || 'currentColor'
  }));
};
export default SvgTrendingDown;